import { Colors, MagicBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import Add from "./assets/Add.svg"
import AddDark from "./assets/AddDark.svg"
import Question from "./assets/QuestionSmall.svg"
import QuestionDark from "./assets/QuestionDarkSmall.svg"
import { CurrencyTheme } from "./helpers/utils";
import Modal from "styled-react-modal";

export const CheckoutOuterMobileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: 100vh;

    font-family: Inter;
    font-size: 34px;
    font-weight: 600;
    line-height: 41px;
    margin-top: 88px;
    margin-bottom: 88px;

    @media (max-width: ${LayoutConst.screen.md}px) {
        min-height: calc(100vh - 50px);
        width: 100%;
            // background-color: ${Colors.galBlack5};
        background-color: ${Colors.galBlack10};
        align-items: center;
        padding: 24px 16px 60px;
        margin-top: 0;
        margin-bottom: 40px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        // padding: 12px 10px 60px;
        // margin-bottom: 90px;
        gap: 16px;
        padding: 12px 10px 0;
        // margin-bottom: 250px;
        // border:1px solid red;
        height: max-content;
        width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding: 16px 10px 0;
    }
`

export const CheckOutWrapper = styled.div<{
    mobile?: boolean
    mobileDir?: "column" | "column-reverse"
    shortGap?: boolean
}>`
    width: 100%;
    height: fit-content;
    max-height: 90vh;
    display: flex;
    flex-direction: ${p => p.mobile ? (p.mobileDir ?? "column-reverse") : "row"};
    border-radius: 8px;
    gap: 24px;

    @media (max-width: ${LayoutConst.screen.l}px) {
        gap: 24px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 32px;
        max-width: 100vw;
        max-height: fit-content;
        align-items: flex-start;
        ${p => p.shortGap && css`
             gap: 16px;
        `}
    }
`

export const PaymentMethods = styled.div<{height?: number, shrink?: boolean, isGift?:boolean}>`
     position: relative;
    width: auto;
    min-height: 136px;          //высота одного блока
    max-height: 508px;          //высота одного блока + блока с тугриками страны по макету
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${p => !p.shrink && css `flex-shrink: 0;` }
    ${p => p.isGift && css `flex-grow: 1;` }

    padding-top:20px; // чтобы не зарезалась подсказка по валюте
    margin-top:-20px;
    padding-right:25px;
    margin-right:-25px;

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        gap: 16px;

        padding-right: 60px;
        margin-right: -60px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        // min-height: 414px;
        // min-height: 290px;
        // height: 100%;
        // width: ${p => p.isGift ? 'auto' : '50%'};
        width:auto;
        padding-right: ${p => p.isGift ? '40px' : 0};
        margin-right: ${p => p.isGift ? '-40px' : 0};
        padding-top: ${p => p.isGift ? '30px' : 0 };
        margin-top: ${p => p.isGift ? '-30px' : 0};
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        padding-right: 0;
        margin-right: 0;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 8px;
        width: 100%;
        min-height: 126px; 
        padding-right: 0;
        margin-right: 0;
        padding-top:45px;
        margin-top:-45px;
        height: auto;
    }
`

export const PaymentMethod = styled.div<{
    isSelected?: boolean
    isGift?: boolean
    currencyTheme?: CurrencyTheme
    multiplePayments?:boolean
}>`
    position: relative;
    // width: 580px;
    width: 540px;
    border-radius: 8px;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: 0.1s;
    background-color: ${p => p.isSelected
            ? Colors.generalOldBlue
            : p.isGift ? 'inherit' : Colors.galBlack10};
    height: auto;
    cursor: pointer;

    color: ${p => p.isSelected ? `#FEFEFE`: Colors.galBlack73} !important;

    &:hover {
        // background-color: ${p => p.isSelected ? `#6A767A` : `#DADADA`};
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: 288px;
        padding: 12px 16px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
        background-color: ${p => p.isSelected ? Colors.generalOldBlue : Colors.galBlack5};
    }


    ${({isGift}) => (isGift) && css`
        width: 100%;
        border: 1px solid ${Colors.galBlack47}; 

        @media (max-width: ${LayoutConst.screen.mac13}px) {
            width: 288px;
        }

        @media (max-width: ${LayoutConst.screen.l}px) {
        //    width: 296px;
            width:100%;
        }

        @media (max-width: ${LayoutConst.screen.s + 1}px) {
            width: 100%;
        }
    `}

    ${({currencyTheme, isSelected, isGift}) => (currencyTheme === CurrencyTheme.light) && css`
        background-color: ${isSelected ? Colors.generalOldBlue : isGift ? 'inherit' : Colors.galBlack10};

        &:hover {
            background-color: #DADADA;
            background-color: ${isSelected ? `#6A767A` : `#DADADA`};
        }
        // * {
            //     color: ${isSelected ? `#FEFEFE`: Colors.galBlack73} !important;
        // }

        // div[type="real"] > div {
        //     filter: invert(0.66);
        // }
    `}
`

export const PaymentMethodTitle = styled.div<{
    type: "tugrik" | "real"
    lhSmall?: boolean
}>`
    font-family: Inter;
    font-size: 23px;
    font-weight: 600;
    line-height: ${p => p.lhSmall ? 27 :29}px;
    letter-spacing: -0.02em;
        // color: ${p => p.type === "real" ? Colors.galBlack5 : p.theme.payment.chooseMethod.methods.tugriks.title};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 15px;
        line-height: 20px;
    }
`

export const PaymentMethodDesc = styled.div<{
    mobile?: boolean
    type: "tugrik" | "real"
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "11px" : "17px"};
    font-weight: 400;
    line-height: ${p => p.mobile ? "13px" : "22px"};
    letter-spacing: -0.02em;
    color: ${p => p.type === "real" ? Colors.galBlack5 : p.theme.payment.chooseMethod.methods.tugriks.desc};
`

export const ContactDetailsSummaryContainer = styled.div`
    display: grid;
    row-gap: 8px;
    // width: 532px;
`

export const ContactDetailsSummaryItem = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #FEFEFE;
`

export const DelieveryInfo = styled.div`
    padding-top: 24px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #545453;
`

export const PaymentCompositeValue = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
`

export const PaymentValue = styled.div<{
    type?: "tugrik" | "real"
    big?: boolean
}>`
    display: flex;
    align-items: center;
    font-family: Inter;
    font-size: ${p => p.big ? 23 : 17}px;
    font-weight: 600;
    line-height: ${p => p.big ? 27 : 22}px;
    letter-spacing: -0.02em;
    // color: ${p => p.type === "real" ? Colors.galBlack5 : p.theme.payment.chooseMethod.methods.tugriks.paymentVal};

    > div {
        height: ${p => p.big ? 24 : 20}px;
        width: ${p => p.big ? 24 : 20}px;
    }

     @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: ${p => p.big ? 20 : 15}px;
        line-height: ${p => p.big ? 25 : 20}px;

         > div {
        height: ${p => p.big ? 16 : 12}px;
        width: ${p => p.big ? 16 : 12}px;
    }
     }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: ${p => p.big ? 17 : 13}px;
        line-height: ${p => p.big ? 22 : 16}px;
    }
`

export const ContactInfoForm = styled.div`
    display: grid;
    row-gap: 12px;
`

export const ContactInfoInput = styled.input`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15px 16px 13px;
    gap: 12px;
    // width: 532px;
    height: 44px;
    background: #F2F2F2;
    border-radius: 3px;
    border: none;
    outline: none;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
`

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 8px;

    & > div > div:nth-child(2) > div:nth-child(2) {
        white-space: break-spaces;

        @media (max-width: ${LayoutConst.screen.l}px) {
            max-width: 320px;
        }

        @media (max-width: ${LayoutConst.screen.s}px) {
            max-width: fit-content;
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        margin-left: 0;
    }
`

export const AddButton = styled.div<{
    dark?: boolean
}>`
    width: 32px;
    height: 32px;
    background-image: ${p => !p.dark ? `url(${Add})` : `url(${AddDark})`};
    transition-duration: 0.1s;

    &:hover {
        transform: scale(0.95);
    }
`


export const RectButtonWrapper = styled.div<{
    dark?: boolean
}>`
    font-size: initial;
    line-height: initial;
    transition-duration: 0.1s;
    display:flex;

    &:hover {
        transform: scale(0.95);
    }

    svg {
        width: 28px;
        height: 28px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
       svg {
         width: 22px;
         height: 22px;
       }
    }

    ${({dark}) => (dark) && css`
        path {
            fill: ${Colors.galBlack73};
        }
        rect {
            stroke: ${Colors.galBlack73};
        }
    `}
`

export const PaymentHint = styled.div<{
    direction: "left" | "right"
}>`
    position: absolute;
    background-color: ${p => p.theme.sendGift.black};
    width: 500px;
    max-width: 50vw;
    border-radius: 6px;
    padding: 12px 16px;
    display: none;
    opacity: 0;
    ${p => p.direction === "right" ?
            css`
                right: 52px;
            ` :
            css`
                left: 52px;
            `
    }
    align-items: center;

    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    color: ${p => p.theme.sendGift.background};

    &::before {
        content: "";
        position: absolute;
        ${p => p.direction === "right" ?
                css`
                    right: -15px;
                ` :
                css`
                    left: -15px;
                `
        }
        width: 18px;
        height: 20px;
        clip-path: ${p => p.direction === "right" ? "polygon(0 0, 0% 100%, 100% 50%)" : "polygon(100% 0, 0 50%, 100% 100%)"};
        background-color: ${p => p.theme.sendGift.black};

    }
`

export const QuestionButton = styled.div<{
    dark?: boolean
    size?: string
}>`
    width: ${p => p.size ? p.size : "32px"};
    height: ${p => p.size ? p.size : "32px"};
    background-image: ${p => !p.dark ? `url(${Question})` : `url(${QuestionDark})`};
    background-size: contain;
    transition-duration: 0.1s;
    position: relative;
    display: flex;
    align-items: center;

    &:hover {
        transform: scale(0.95);
    }

    &:hover ${PaymentHint} {
        opacity: 1;
        display: flex;

    }
`

export const PaymentMethodBottom = styled.div<{
    mobile: boolean
    justify?: string
}>`
    display: flex;
    gap: 24px;
    justify-content: ${p => p?.justify || 'space-between'};
    align-items: center;
    margin-top: ${p => p.mobile ? "24px" : "0"};

 @media (max-width: ${LayoutConst.screen.mac13}px) {
           align-items: flex-end;
        }        

        @media (max-width: ${LayoutConst.screen.md}px) {
            margin-top: 0;
            gap: 8px;
        }
`

export const AdditionalText = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: ${p => p.theme.payment.chooseMethod.methods.tugriks.additional};
`

export const PaymentMethodCheckbox = styled.div<{
    selected: boolean
}>`
    position: absolute;
    right: 24px;
    top: 24px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${Colors.galBlack5};

    &::after {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${Colors.galBlack100};
        display: ${p => p.selected ? "block" : "none"}
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        top: 16px;
        right: 16px;
    }
`

export const Summary = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }
`


export const PaymentModal = Modal.styled`
    width: 100%;
    max-width: min(1152px, 90vw);
    // position: absolute;
    top: 107px;
    // height: 80%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 0px;
    }
`

export const SpinnerBlock = styled(MagicBox)`
    transform: translateY(-4px);
`

export const PaymentButton = styled.button<{
    fullWidth?: boolean
}>`
    cursor: pointer;
    user-select: none;
    padding: 12px 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${p => p.fullWidth ? "100%" : "auto"};
    border-radius: 3px;
    border: none;
    outline: none;


    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        padding: 10px 24px;
        font-size: 15px;
        line-height: 20px;
    };

`

export const PaymentButtonHollow = styled(PaymentButton)<{buttonTheme?: string}>`
    border: 1px solid ${Colors.galBlack31};
    color: ${p => (p?.buttonTheme === 'black') ? Colors.galBlack31 : Colors.galBlack100};
    ${p => (p?.buttonTheme === 'black') ? 'Background: inherit' : ''};
    width: 190px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: 122px;
    };

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    };

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
    };
`

export const PaymentButtonSolid = styled(PaymentButton)<{
    buttonTheme?: string,
    disabled?: boolean,
    isGift?: boolean,
    fullWidth?: boolean
    noWidthLimitation?:boolean,
    leveling?: boolean
}>`
    // min-width: 145px;
    width: ${p => p.fullWidth ? '100%' : p.noWidthLimitation ? 'auto' : '190px'};
    background-color: ${p => p.disabled
            ? Colors.galBlack47
            : (p?.buttonTheme === 'yellow')
                    ? Colors.uiYellowEnabled
                    : Colors.galBlack100
    };
    color: ${p => Colors.gal};
    cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
    justify-self: flex-end;

    ${({ leveling }) => leveling && css`text-align: center;`};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: ${p=> p.fullWidth ? '100%' : p.noWidthLimitation ? 'auto' : '122px'};
    };
    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
    };
    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }

`

export const FormTitle = styled(MagicBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;
    color: ${Colors.galBlack100};
    letter-spacing: -0.02em;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 30px;
        line-height: 33px;
        // margin-bottom: 16px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        // width: 712px;
        // align-self: center;
        // margin-bottom: 8px;
        width: 712px;
        align-self: center;

    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        font-size: 20px;
        line-height: 25px;
        margin-bottom: 0px;

    }
`

export const BalanceContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`

export const BalanceInfo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const BalanceTitle = styled.div`
        // color: ${Colors.gal};
    margin-right: 8px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const PaymentMethodHeader = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    svg {
        width: 24px;
        height: 24px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        margin-bottom: 8px;
        svg {
            width: 16px;
            height: 16px;
        }
    }
`

export const GiftMethodsContainer = styled(MagicBox)`
    width: 420px;
    // height: 100%;
    height: fit-content;
    background-color: ${Colors.galBlack5};
    border-radius: 8px;
    padding: 32px 24px;
    display: flex;
    flex-direction: column;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: 320px;
        padding: 24px 16px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        // padding: 24px 16px;
        padding: 0px;
        background-color: inherit;
    }

`
export const GiftMethodsWrapper = styled(MagicBox)``

export const GiftNextButtonPlace = styled(MagicBox)`
    margin-top: 32px;
    justify-content: flex-end;
    width: 100%;    

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        margin-top: 24px;
    }
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 16px;
        button {
            width: 100%;
        }
    }
`import { Colors, MagicBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import Add from "./assets/Add.svg"
import AddDark from "./assets/AddDark.svg"
import Question from "./assets/QuestionSmall.svg"
import QuestionDark from "./assets/QuestionDarkSmall.svg"
import { CurrencyTheme } from "./helpers/utils";
import Modal from "styled-react-modal";

export const CheckoutOuterMobileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: 100vh;

    font-family: Inter;
    font-size: 34px;
    font-weight: 600;
    line-height: 41px;
    margin-top: 88px;
    margin-bottom: 88px;

    @media (max-width: ${LayoutConst.screen.md}px) {
        min-height: calc(100vh - 50px);
        width: 100%;
            // background-color: ${Colors.galBlack5};
        background-color: ${Colors.galBlack10};
        align-items: center;
        padding: 24px 16px 60px;
        margin-top: 0;
        margin-bottom: 40px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        // padding: 12px 10px 60px;
        // margin-bottom: 90px;
        gap: 16px;
        padding: 12px 10px 0;
        // margin-bottom: 250px;
        // border:1px solid red;
        height: max-content;
        width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding: 16px 10px 0;
    }
`

export const CheckOutWrapper = styled.div<{
    mobile?: boolean
    mobileDir?: "column" | "column-reverse"
    shortGap?: boolean
}>`
    width: 100%;
    height: fit-content;
    max-height: 90vh;
    display: flex;
    flex-direction: ${p => p.mobile ? (p.mobileDir ?? "column-reverse") : "row"};
    border-radius: 8px;
    gap: 24px;

    @media (max-width: ${LayoutConst.screen.l}px) {
        gap: 24px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 32px;
        max-width: 100vw;
        max-height: fit-content;
        align-items: flex-start;
        ${p => p.shortGap && css`
             gap: 16px;
        `}
    }
`

export const PaymentMethods = styled.div<{height?: number, shrink?: boolean, isGift?:boolean}>`
     position: relative;
    width: auto;
    min-height: 136px;          //высота одного блока
    max-height: 508px;          //высота одного блока + блока с тугриками страны по макету
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${p => !p.shrink && css `flex-shrink: 0;` }
    ${p => p.isGift && css `flex-grow: 1;` }

    padding-top:20px; // чтобы не зарезалась подсказка по валюте
    margin-top:-20px;
    padding-right:25px;
    margin-right:-25px;

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        gap: 16px;

        padding-right: 60px;
        margin-right: -60px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        // min-height: 414px;
        // min-height: 290px;
        // height: 100%;
        // width: ${p => p.isGift ? 'auto' : '50%'};
        width:auto;
        padding-right: ${p => p.isGift ? '40px' : 0};
        margin-right: ${p => p.isGift ? '-40px' : 0};
        padding-top: ${p => p.isGift ? '30px' : 0 };
        margin-top: ${p => p.isGift ? '-30px' : 0};
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        padding-right: 0;
        margin-right: 0;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 8px;
        width: 100%;
        min-height: 126px; 
        padding-right: 0;
        margin-right: 0;
        padding-top:45px;
        margin-top:-45px;
        height: auto;
    }
`

export const PaymentMethod = styled.div<{
    isSelected?: boolean
    isGift?: boolean
    currencyTheme?: CurrencyTheme
    multiplePayments?:boolean
}>`
    position: relative;
    // width: 580px;
    width: 540px;
    border-radius: 8px;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: 0.1s;
    background-color: ${p => p.isSelected
            ? Colors.generalOldBlue
            : p.isGift ? 'inherit' : Colors.galBlack10};
    height: auto;
    cursor: pointer;

    color: ${p => p.isSelected ? `#FEFEFE`: Colors.galBlack73} !important;

    &:hover {
        // background-color: ${p => p.isSelected ? `#6A767A` : `#DADADA`};
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: 288px;
        padding: 12px 16px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
        background-color: ${p => p.isSelected ? Colors.generalOldBlue : Colors.galBlack5};
    }


    ${({isGift}) => (isGift) && css`
        width: 100%;
        border: 1px solid ${Colors.galBlack47}; 

        @media (max-width: ${LayoutConst.screen.mac13}px) {
            width: 288px;
        }

        @media (max-width: ${LayoutConst.screen.l}px) {
        //    width: 296px;
            width:100%;
        }

        @media (max-width: ${LayoutConst.screen.s + 1}px) {
            width: 100%;
        }
    `}

    ${({currencyTheme, isSelected, isGift}) => (currencyTheme === CurrencyTheme.light) && css`
        background-color: ${isSelected ? Colors.generalOldBlue : isGift ? 'inherit' : Colors.galBlack10};

        &:hover {
            background-color: #DADADA;
            background-color: ${isSelected ? `#6A767A` : `#DADADA`};
        }
        // * {
            //     color: ${isSelected ? `#FEFEFE`: Colors.galBlack73} !important;
        // }

        // div[type="real"] > div {
        //     filter: invert(0.66);
        // }
    `}
`

export const PaymentMethodTitle = styled.div<{
    type: "tugrik" | "real"
    lhSmall?: boolean
}>`
    font-family: Inter;
    font-size: 23px;
    font-weight: 600;
    line-height: ${p => p.lhSmall ? 27 :29}px;
    letter-spacing: -0.02em;
        // color: ${p => p.type === "real" ? Colors.galBlack5 : p.theme.payment.chooseMethod.methods.tugriks.title};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 15px;
        line-height: 20px;
    }
`

export const PaymentMethodDesc = styled.div<{
    mobile?: boolean
    type: "tugrik" | "real"
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "11px" : "17px"};
    font-weight: 400;
    line-height: ${p => p.mobile ? "13px" : "22px"};
    letter-spacing: -0.02em;
    color: ${p => p.type === "real" ? Colors.galBlack5 : p.theme.payment.chooseMethod.methods.tugriks.desc};
`

export const ContactDetailsSummaryContainer = styled.div`
    display: grid;
    row-gap: 8px;
    // width: 532px;
`

export const ContactDetailsSummaryItem = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #FEFEFE;
`

export const DelieveryInfo = styled.div`
    padding-top: 24px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #545453;
`

export const PaymentCompositeValue = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
`

export const PaymentValue = styled.div<{
    type?: "tugrik" | "real"
    big?: boolean
}>`
    display: flex;
    align-items: center;
    font-family: Inter;
    font-size: ${p => p.big ? 23 : 17}px;
    font-weight: 600;
    line-height: ${p => p.big ? 27 : 22}px;
    letter-spacing: -0.02em;
    // color: ${p => p.type === "real" ? Colors.galBlack5 : p.theme.payment.chooseMethod.methods.tugriks.paymentVal};

    > div {
        height: ${p => p.big ? 24 : 20}px;
        width: ${p => p.big ? 24 : 20}px;
    }

     @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: ${p => p.big ? 20 : 15}px;
        line-height: ${p => p.big ? 25 : 20}px;

         > div {
        height: ${p => p.big ? 16 : 12}px;
        width: ${p => p.big ? 16 : 12}px;
    }
     }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: ${p => p.big ? 17 : 13}px;
        line-height: ${p => p.big ? 22 : 16}px;
    }
`

export const ContactInfoForm = styled.div`
    display: grid;
    row-gap: 12px;
`

export const ContactInfoInput = styled.input`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15px 16px 13px;
    gap: 12px;
    // width: 532px;
    height: 44px;
    background: #F2F2F2;
    border-radius: 3px;
    border: none;
    outline: none;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
`

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 8px;

    & > div > div:nth-child(2) > div:nth-child(2) {
        white-space: break-spaces;

        @media (max-width: ${LayoutConst.screen.l}px) {
            max-width: 320px;
        }

        @media (max-width: ${LayoutConst.screen.s}px) {
            max-width: fit-content;
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        margin-left: 0;
    }
`

export const AddButton = styled.div<{
    dark?: boolean
}>`
    width: 32px;
    height: 32px;
    background-image: ${p => !p.dark ? `url(${Add})` : `url(${AddDark})`};
    transition-duration: 0.1s;

    &:hover {
        transform: scale(0.95);
    }
`


export const RectButtonWrapper = styled.div<{
    dark?: boolean
}>`
    font-size: initial;
    line-height: initial;
    transition-duration: 0.1s;
    display:flex;

    &:hover {
        transform: scale(0.95);
    }

    svg {
        width: 28px;
        height: 28px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
       svg {
         width: 22px;
         height: 22px;
       }
    }

    ${({dark}) => (dark) && css`
        path {
            fill: ${Colors.galBlack73};
        }
        rect {
            stroke: ${Colors.galBlack73};
        }
    `}
`

export const PaymentHint = styled.div<{
    direction: "left" | "right"
}>`
    position: absolute;
    background-color: ${p => p.theme.sendGift.black};
    width: 500px;
    max-width: 50vw;
    border-radius: 6px;
    padding: 12px 16px;
    display: none;
    opacity: 0;
    ${p => p.direction === "right" ?
            css`
                right: 52px;
            ` :
            css`
                left: 52px;
            `
    }
    align-items: center;

    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    color: ${p => p.theme.sendGift.background};

    &::before {
        content: "";
        position: absolute;
        ${p => p.direction === "right" ?
                css`
                    right: -15px;
                ` :
                css`
                    left: -15px;
                `
        }
        width: 18px;
        height: 20px;
        clip-path: ${p => p.direction === "right" ? "polygon(0 0, 0% 100%, 100% 50%)" : "polygon(100% 0, 0 50%, 100% 100%)"};
        background-color: ${p => p.theme.sendGift.black};

    }
`

export const QuestionButton = styled.div<{
    dark?: boolean
    size?: string
}>`
    width: ${p => p.size ? p.size : "32px"};
    height: ${p => p.size ? p.size : "32px"};
    background-image: ${p => !p.dark ? `url(${Question})` : `url(${QuestionDark})`};
    background-size: contain;
    transition-duration: 0.1s;
    position: relative;
    display: flex;
    align-items: center;

    &:hover {
        transform: scale(0.95);
    }

    &:hover ${PaymentHint} {
        opacity: 1;
        display: flex;

    }
`

export const PaymentMethodBottom = styled.div<{
    mobile: boolean
    justify?: string
}>`
    display: flex;
    gap: 24px;
    justify-content: ${p => p?.justify || 'space-between'};
    align-items: center;
    margin-top: ${p => p.mobile ? "24px" : "0"};

 @media (max-width: ${LayoutConst.screen.mac13}px) {
           align-items: flex-end;
        }        

        @media (max-width: ${LayoutConst.screen.md}px) {
            margin-top: 0;
            gap: 8px;
        }
`

export const AdditionalText = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: ${p => p.theme.payment.chooseMethod.methods.tugriks.additional};
`

export const PaymentMethodCheckbox = styled.div<{
    selected: boolean
}>`
    position: absolute;
    right: 24px;
    top: 24px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${Colors.galBlack5};

    &::after {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${Colors.galBlack100};
        display: ${p => p.selected ? "block" : "none"}
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        top: 16px;
        right: 16px;
    }
`

export const Summary = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }
`


export const PaymentModal = Modal.styled`
    width: 100%;
    max-width: min(1152px, 90vw);
    // position: absolute;
    top: 107px;
    // height: 80%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 0px;
    }
`

export const SpinnerBlock = styled(MagicBox)`
    transform: translateY(-4px);
`

export const PaymentButton = styled.button<{
    fullWidth?: boolean
}>`
    cursor: pointer;
    user-select: none;
    padding: 12px 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${p => p.fullWidth ? "100%" : "auto"};
    border-radius: 3px;
    border: none;
    outline: none;


    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        padding: 10px 24px;
        font-size: 15px;
        line-height: 20px;
    };

`

export const PaymentButtonHollow = styled(PaymentButton)<{buttonTheme?: string}>`
    border: 1px solid ${Colors.galBlack31};
    color: ${p => (p?.buttonTheme === 'black') ? Colors.galBlack31 : Colors.galBlack100};
    ${p => (p?.buttonTheme === 'black') ? 'Background: inherit' : ''};
    width: 190px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: 122px;
    };

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    };

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
    };
`

export const PaymentButtonSolid = styled(PaymentButton)<{
    buttonTheme?: string,
    disabled?: boolean,
    isGift?: boolean,
    fullWidth?: boolean
    noWidthLimitation?:boolean,
    leveling?: boolean
}>`
    // min-width: 145px;
    width: ${p => p.fullWidth ? '100%' : p.noWidthLimitation ? 'auto' : '190px'};
    background-color: ${p => p.disabled
            ? Colors.galBlack47
            : (p?.buttonTheme === 'yellow')
                    ? Colors.uiYellowEnabled
                    : Colors.galBlack100
    };
    color: ${p => Colors.gal};
    cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
    justify-self: flex-end;

    ${({ leveling }) => leveling && css`text-align: center;`};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: ${p=> p.fullWidth ? '100%' : p.noWidthLimitation ? 'auto' : '122px'};
    };
    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
    };
    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }

`

export const FormTitle = styled(MagicBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;
    color: ${Colors.galBlack100};
    letter-spacing: -0.02em;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 30px;
        line-height: 33px;
        // margin-bottom: 16px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        // width: 712px;
        // align-self: center;
        // margin-bottom: 8px;
        width: 712px;
        align-self: center;

    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        font-size: 20px;
        line-height: 25px;
        margin-bottom: 0px;

    }
`

export const BalanceContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`

export const BalanceInfo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const BalanceTitle = styled.div`
        // color: ${Colors.gal};
    margin-right: 8px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const PaymentMethodHeader = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    svg {
        width: 24px;
        height: 24px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        margin-bottom: 8px;
        svg {
            width: 16px;
            height: 16px;
        }
    }
`

export const GiftMethodsContainer = styled(MagicBox)`
    width: 420px;
    // height: 100%;
    height: fit-content;
    background-color: ${Colors.galBlack5};
    border-radius: 8px;
    padding: 32px 24px;
    display: flex;
    flex-direction: column;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        width: 320px;
        padding: 24px 16px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        // padding: 24px 16px;
        padding: 0px;
        background-color: inherit;
    }

`
export const GiftMethodsWrapper = styled(MagicBox)``

export const GiftNextButtonPlace = styled(MagicBox)`
    margin-top: 32px;
    justify-content: flex-end;
    width: 100%;    

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        margin-top: 24px;
    }
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 16px;
        button {
            width: 100%;
        }
    }
`